import { graphql, useStaticQuery } from "gatsby";

const FlightsNoResultsQuery = () => {
	const { allContentfulComponentWrapper: data } = useStaticQuery(
		graphql`
			query FlightsNoResultsQueryQuery {
				allContentfulComponentWrapper(filter: { contentful_id: { eq: "2PCS2BGoLN7CHEpLzajLXV" } }) {
					edges {
						node {
							node_locale
							title
							padding
							wrapperSections {
								pageSections {
									... on ContentfulCardCollection {
										cards {
											... on ContentfulLinkTile {
												title
												displayTitle
												subTitle
												subTitle2
												variant
												color
												link {
													... on ContentfulLink {
														linkText
														url
														target
													}
												}
												cloudinaryImage {
													secure_url
													width
													height
													raw_transformation
													version
													public_id
													format
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		`
	);

	return data.edges;
};

export default FlightsNoResultsQuery;
export { FlightsNoResultsQuery };
